import { IToken } from './../../shared/contexts/styleContext/interfaces/Token';
import { css } from '@emotion/core';

export const mediaManagementContainerWrapperStyle = (token: IToken) => css`
    padding: ${token.spacings.medium};
    margin: ${token.spacings.smaller};
`;
